<nav class="navbar navbar-expand-lg logo-background-color">
  <a [routerLink]="['/']">
    <img *ngIf="!environment.ADMINNAVBAR.HAS || !environment.ADMINNAVBAR.PORTAL_CONFIGURATION"
      [src]="LOGO" class="d-inline-block align-top size-100" alt="Logo">
    <img
      *ngIf="environment.ADMINNAVBAR.HAS && environment.ADMINNAVBAR.PORTAL_CONFIGURATION && _portalConfigurationService.configuration"
      [src]="_portalConfigurationService.configuration?.logoURL.name"
      class="d-inline-block align-top size-100" alt="Logo">
  </a>
</nav>

<!-- Navbars -->
<div
  *ngIf="!_portalConfigurationService.configuration?.maintenanceMode || 
_portalConfigurationService.configuration?.maintenanceMode?.name =='false' || 
_userService.user?.role == 'superadmin' || 
_portalConfigurationService.configuration?.usersForMaintenanceMode?.name.includes(_userService.user?.email)">

  <!-- User navbar -->
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark" *ngIf="!adminNavBar.HAS || _userService.user?.role != 'admin' && 
     _userService.user?.role != 'superadmin' &&  
     _userService.user?.role != 'consultant' &&  
     _userService.user?.role != 'assistant'"
    [ngClass]="NAVBARMAINCOLOR  ? 'navbar-main-color' : 'navbar-secondary-color'">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
      aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav mr-auto" [hidden]="_userService.user && _userService.user.passInitial">
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['user/myappointments']" *ngIf="_userService.user">{{
            'MY_APPOINTMENTS' |
            translate}} </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['bookappointments']">{{ 'BOOK_APPOINTMENT' | translate
            }}</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['secondopinion']" *ngIf="hasSecondOpinion">{{
            'SECOND_OPINION' | translate
            }}</a>
        </li>
        <li class="nav-item" routerLinkActive="active" *ngIf="hasMyDocuments">
          <a class="nav-link" [routerLink]="['user/mydocuments']" *ngIf="_userService.user">{{
            'MY_DOCUMENTS' | translate}}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active" *ngIf="hasMydepents">
          <a class="nav-link" [routerLink]="['user/mydependents']" *ngIf="_userService.user">{{
            'MY_DEPENDENTS' | translate}}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['user/accountinfo']" *ngIf="_userService.user">{{
            'ACCOUNT_INFO' | translate}}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['faq']">{{ 'FAQ' | translate
            }}</a>
        </li>
      </ul>
      <ul>
      </ul>
    </div>
    <lang-selector *ngIf="!hideLanguageSelector"></lang-selector>
    <div class="navbar-nav float-right">
      <button class="btn btn-secondary-color btn-sm custom-color" data-toggle="modal"
        data-target="#LoginModal" *ngIf="!_userService.user" (click)="clearAlerts()">{{
        'LOGIN' | translate }}</button>
      <button class="btn btn-secondary-color btn-sm custom-color" (click)="logout()"
        *ngIf="_userService.user">{{
        'LOGOUT' | translate }} <i class="fas fa-sign-out-alt"></i></button>
      <button [routerLink]="['register']" class="btn btn-secondary-color btn-sm custom-color"
        *ngIf="!_userService.user" data-toggle="modal" data-target="#PinModal"
        (click)="clearAlerts()">{{
        'REGISTER' | translate }} </button>
      <!--     <button [routerLink]="['register']" class="btn btn-secondary-color btn-sm custom-color"
      *ngIf="!_userService.user && environmentName == 'typet'" data-toggle="modal"
      data-target="#PinModal" (click)="clearAlerts()">{{
      'REGISTER' | translate }} </button> -->
    </div>
  </nav>

  <!-- Admin navbar -->

  <nav class="navbar-dark navbar navbar-expand-lg bg-danger" *ngIf="adminNavBar.HAS && _userService.user?.role == 'admin' || 
  adminNavBar.HAS && _userService.user?.role == 'superadmin'">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#adminNavbar"
      aria-controls="adminNavbar" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="adminNavbar">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item" routerLinkActive="active" *ngIf="adminNavBar.USERMANGEMENT">
          <a class="nav-link text-light" [routerLink]="['admin/user-management']">{{
            'USER_MANAGEMENT' | translate}}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active"
          *ngIf="adminNavBar.PORTAL_CONFIGURATION && _userService.user?.role == 'superadmin'">
          <a class="nav-link text-light"
            [routerLink]="['admin/portal-configuration/portal-parameters']">
            {{ 'PORTAL_CONFIGURATION' | translate}}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active" *ngIf="adminNavBar.REPORTS.HAS">
          <a class="nav-link text-light" [routerLink]="['admin/reports/login-attemps']">
            {{ 'REPORTS' | translate}}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active" *ngIf="resourcesOnDatabase">
          <a class="nav-link text-light" [routerLink]="['admin/database-resources/hospitals']">
            {{ 'RESOURCES_ON_DATABASE' | translate}}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link text-light" [routerLink]="['admin/tools/clear-cache']">
            {{ 'TOOLS' | translate}}
          </a>
        </li>
      </ul>
      <ul>
      </ul>
      <lang-selector *ngIf="!hideLanguageSelector"></lang-selector>
    </div>
    <div class="navbar-nav float-right">
      <button class="btn btn-secondary-color btn-sm custom-color" (click)="logout()"
        *ngIf="_userService.user">{{
        'LOGOUT' | translate }} <i class="fas fa-sign-out-alt"></i></button>
    </div>
  </nav>


  <!-- Consultant navbar -->

  <nav class="navbar navbar-expand-lg bg-secondary navbar-dark"
    *ngIf="adminNavBar.HAS && _userService.user?.role == 'consultant'">
    <button class="navbar-toggler" type="button" data-toggle="collapse"
      data-target="#consultantNavbar" aria-controls="adminNavbar" aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="consultantNavbar">
      <a class=" navbar-brand">{{ 'CONSULTANT_NAVBAR' | translate }}</a>
      <ul class="navbar-nav mr-auto" [hidden]="_userService.user && _userService.user.passInitial">

        <li class="nav-item" routerLinkActive="active" *ngIf=false>
          <a class="nav-link secondary-color" [routerLink]="['admin/consultant/appointments']">{{
            'APPOINTMENTS' | translate}}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active" *ngIf="resourcesOnDatabase">
          <a class="nav-link text-light"
            [routerLink]="['admin/database-resources/consultants/edit-consultant']">
            {{ 'PROFILE' | translate}}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link text-light" [routerLink]="['admin/tools/clear-cache']">
            {{ 'TOOLS' | translate}}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['user/accountinfo']" *ngIf="_userService.user">{{
            'ACCOUNT_INFO' | translate}}
          </a>
        </li>
      </ul>
      <ul>
      </ul>
      <lang-selector *ngIf="!hideLanguageSelector"></lang-selector>
    </div>
    <div class="navbar-nav float-right">
      <button class="btn btn-secondary-color btn-sm custom-color" (click)="logout()"
        *ngIf="_userService.user">{{
        'LOGOUT' | translate }} <i class="fas fa-sign-out-alt"></i></button>
    </div>
  </nav>

  <!-- Assistant navbar -->

  <nav class="navbar navbar-expand-lg bg-secondary navbar-dark"
    *ngIf="adminNavBar.HAS && _userService.user?.role == 'assistant'">
    <button class="navbar-toggler" type="button" data-toggle="collapse"
      data-target="#assistantNavbar" aria-controls="adminNavbar" aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="consultantNavbar">
      <a class=" navbar-brand">{{ 'ASSISTANT_NAVBAR' | translate }}</a>
      <ul class="navbar-nav mr-auto" [hidden]="_userService.user && _userService.user.passInitial">

        <li class="nav-item" routerLinkActive="active" *ngIf="resourcesOnDatabase">
          <a class="nav-link text-light" [routerLink]="['admin/database-resources/consultants']">
            {{ 'MY_CONSULTANTS' | translate}}
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" [routerLink]="['user/accountinfo']" *ngIf="_userService.user">{{
            'ACCOUNT_INFO' | translate}}
          </a>
        </li>
      </ul>
      <ul>
      </ul>
      <lang-selector *ngIf="!hideLanguageSelector"></lang-selector>
    </div>
    <div class="navbar-nav float-right">
      <button class="btn btn-secondary-color btn-sm custom-color" (click)="logout()"
        *ngIf="_userService.user">{{
        'LOGOUT' | translate }} <i class="fas fa-sign-out-alt"></i></button>
    </div>
  </nav>

</div>

<!-- Alerta desde la configuración del Portal -->
<div class="text-center alert alert-primary"
  *ngIf="_portalConfigurationService.configuration?.messageInPortal?.name == 'true'">
  {{_portalConfigurationService.configuration?.textOnMessageInPortal?.name}}
</div>

<!-- FIN DE LA Alerta desde la configuración del Portal -->


<!-- The Login Modal -->
<div class="modal fade" id="LoginModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">{{ 'AUTHENTICATION' | translate}} </h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <div *ngIf="_userService.success" class="alert alert-success" role="alert">
          {{_userService.success | translate }}
        </div>
        <div *ngIf="_authService.alert || _userService.warning" class="alert alert-warning"
          role="alert">
          {{ _authService.alert | translate }} {{ _userService.warning | translate }}
        </div>
        <div class="form-group row"
          *ngIf="_authService.alert == 'PLEASE_CONFIRM_YOUR_MAIL_BEFORE_ACCESSING'">
          <div class="form-group col-md-6">
          </div>
          <div class="col-md-6">
            <button class="btn btn-secondary-color btn-sm pull-right"
              (click)="resendActivationMail()">
              {{ 'RESEND_ACTIVATION_MAIL' | translate}}
            </button>
          </div>
        </div>


        <form>
          <div class="text-center alert background-main-color" *ngIf="_authService.loading">
            <i class="fa fa-refresh fa-spin font-size-20"></i>
            <span> {{ loging | translate}}...</span>
          </div>
          <div class="form-group row">
            <div class="form-group col-md-6">
              <label>{{ 'USERNAME_EMAIL' | translate}} </label>
              <input class="form-control" type="text" [value]="login.username" name="username"
                [(ngModel)]=login.username autocomplete="off">
            </div>
            <div class="col-md-6">
              <label>{{ 'PASSWORD' | translate}} </label>
              <input class="form-control" type="password" [value]="login.password" name="password"
                [(ngModel)]=login.password autocomplete="new-password">
            </div>
          </div>
          <div class="form-group row">
            <div class="form-group col-md-6">
              <button type="submit" class="btn btn-main-color btn-block" (click)="doLogin()">
                {{ 'LOGIN' | translate}}
              </button>
            </div>
            <div class="col-md-6">
              <button type="submit" class="btn btn-secondary btn-block" data-dismiss="modal">
                {{ 'CANCEL' | translate}}
              </button>
              <p></p>
              <button type="submit" class="btn btn-secondary-color btn-sm pull-right"
                data-dismiss="modal" data-toggle="modal" data-target="#ResetPasswordModal">
                {{ 'FORGET_PASSWORD' | translate}}
              </button>

            </div>
          </div>
        </form>
      </div>

    </div>
  </div>
</div>




<!-- The Reset Password Modal -->
<div class="modal fade" id="ResetPasswordModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">{{ 'RESET_PASSWORD' | translate}} </h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body" *ngIf="environmentName == 'typet'">
        <div class="alert alert-success" role="alert">
          {{ 'TYPET_RESET_PASS' | translate }}
        </div>

      </div>
      <div class="modal-body" *ngIf="environmentName != 'typet'">
        <div *ngIf="_userService.success" class="alert alert-success" role="alert">
          {{ _userService.success | translate }}
        </div>
        <div *ngIf="_userService.warning" class="alert alert-warning" role="alert">
          {{ _userService.warning | translate }}
        </div>
        <form>
          <div class="text-center alert background-main-color" *ngIf="_userService.loading">
            <i class="fa fa-refresh fa-spin font-size-20"></i>
            <span> {{ LOADING | translate}}...</span>
          </div>
          <div class="form-group row">
            <div class="form-group col-md-12">
              <label>{{ 'USERNAME_EMAIL' | translate}} </label>
              <input class="form-control" type="text" [value]="login.username" name="username"
                [(ngModel)]=login.username>
            </div>
          </div>
          <div class="form-group row">
            <div class="form-group col-md-6">
              <button type="submit" class="btn btn-main-color btn-block" (click)="resetPassword()">
                {{ 'SEND_NEW_PASSWORD' | translate}}
              </button>
            </div>
            <div class="col-md-6">
              <button type="submit" class="btn btn-secondary btn-block" data-dismiss="modal">
                {{ 'CANCEL' | translate}}
              </button>
            </div>
          </div>
        </form>
      </div>

    </div>
  </div>
</div>



<!-- The Remember filation (ASIS petition) Modal -->
<div class="modal fade" id="RememberFilationModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">{{ 'WARNING' | translate}} </h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <div class="alert alert-warning" role="alert">
          {{ _userService.warning | translate }}
        </div>
        <div class="col-md-12">
          <button type="submit" class="btn btn-secondary btn-block" data-dismiss="modal">
            {{ 'OK' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>





<!-- The Old Browser Detected Modal -->
<div class="modal fade" id="OldBrowserDetected">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">{{ 'WARNING' | translate}} </h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <div class="alert alert-warning" role="alert">
          <p [innerHtml]="'OLD_BROWSER_DETCTED' | translate"></p>
        </div>
        <div class="col-md-12">
          <button type="submit" class="btn btn-secondary btn-block" data-dismiss="modal">
            {{ 'OK' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>